/**
 * Invoice table column definitions
 *
 * @param {Function} t
 * @param {string} type
 * @param {Function} isTheme
 */
export const getInvoiceListColumns = (t, type, isTheme) => {
  const isFinancia = isTheme('financia')

  return [
    { name: 'id', displayable: false },
    { name: 'entityId', displayable: false },
    { name: 'companyId', displayable: false },
    {
      name: 'number',
      style: { className: 'text-center' },
      formatter: 'context',
      options: { renderType: type === 'SUPPLIER' ? 'supplierInvoice' : 'invoice' },
      title: t('invoice.list.number'),
    },
    {
      name: 'contractNumber',
      style: { className: 'text-center' },
      title: t('invoice.list.contractNumber'),
      formatter: 'context',
      options: { renderType: 'contracts', renderId: 'contractId' },
    },
    {
      name: 'companyName',
      title: t('invoice.list.companyName'),
      formatter: 'entity',
      options: { renderId: 'companyId' },
      displayable: !isFinancia,
    },
    {
      name: 'entityName',
      title: t(type === 'CLIENT' ? 'invoice.list.entityName' : 'invoice.list.supplierName'),
      formatter: 'entity',
      options: { renderId: 'entityId' },
    },
    {
      name: 'clientName',
      title: t('invoice.list.clientName'),
      formatter: 'entity',
      options: { renderId: 'clientId' },
      displayable: isFinancia,
    },
    {
      name: 'esign',
      displayable: isFinancia,
      title: t('invoice.list.esign'),
      style: { className: 'text-center' },
      formatter: 'boolean',
    },
    {
      name: 'demandNumber',
      displayable: isFinancia,
      title: t('invoice.list.demandNumber'),
      style: { className: 'text-center' },
    },
    {
      name: 'contractStatus',
      style: { className: 'text-center' },
      title: t('invoice.list.contractStatus'),
      formatter: 'status',
      options: { renderType: 'contract' },
    },
    {
      name: 'status',
      style: { className: 'text-center' },
      title: t('invoice.list.status'),
      formatter: 'status',
      options: { renderType: 'invoice' },
    },
    { name: 'createdAt', title: t('invoice.list.createdAt'), type: 'date', formatter: 'date' },
    {
      name: 'dueAt',
      title: t('invoice.list.dueAt'),
      type: 'date',
      formatter: 'date',
      displayable: !isFinancia,
    },
    {
      name: 'signedAmount',
      title: t('invoice.list.amount'),
      style: { className: 'col-align-right' },
      type: 'num-fmt',
      formatter: 'currency',
    },
    {
      name: 'signedAmountVat',
      title: t('invoice.list.amountVat'),
      style: { className: 'col-align-right' },
      type: 'num-fmt',
      formatter: 'currency',
    },
    {
      name: 'id',
      title: t('invoice.download'),
      style: { className: 'text-center unfollow' },
      formatter: 'action',
      options: { renderType: 'download', renderId: 'id' },
    },
  ]
}
